import type {
  CanCancelResponse,
  PreliminaryContractResponse,
} from '@/features/PreviousInsurance/type';
import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import type { PreviousInsuranceProductCategory } from '@/features/Sparten/pkv/types';

export class PreviousInsuranceHttpService extends HttpService {
  canCancel(clientId: string): HttpClientResponse<CanCancelResponse> {
    return this.httpClient.get(`kunde/${clientId}/vorvertraege/kuendigung`);
  }

  loadPreliminaryContract(
    url: string,
  ): HttpClientResponse<PreliminaryContractResponse> {
    return this.httpClient.get(url, {
      dontUseBaseUrl: true,
    });
  }

  loadProducts(
    insuranceId: string,
    queryParams?: Record<string, unknown>,
  ): HttpClientResponse<PreviousInsuranceProductCategory[]> {
    return this.httpClient.get(
      `gesellschaften/${insuranceId}/tarife/all-time`,
      {
        params: queryParams,
      },
    );
  }
}
